import ConditionalContainer from 'components/foundation/ConditionalContainer/ConditionalContainer';
import {
  USE_KIOSK_PERMISSION_DESCRIPTION,
  USE_KIOSK_PERMISSION_TITLE,
} from 'containers/settings/positions/components/AllowKioskModeFormFields/AllowKioskModeFormFields';
import PositionDetailsBooleanDetail from 'containers/settings/positions/details/PositionDetailsBooleanDetail';
import type React from 'react';
import type IPosition from 'types/Position';
import { useFeatureFlags } from 'utils/features';

interface IKioskPositionDetailDetailProps {
  position: IPosition;
  editable: boolean;
  onUpdate: () => Promise<void>;
}
export const KioskPositionDetail: React.FC<IKioskPositionDetailDetailProps> = (passthrough) => {
  const isUseKioskPermissionEnabled = useFeatureFlags('USE_KIOSK_PERMISSION');

  return (
    <ConditionalContainer condition={isUseKioskPermissionEnabled}>
      <PositionDetailsBooleanDetail
        {...passthrough}
        key={'kiosk-position-detail'}
        title={USE_KIOSK_PERMISSION_TITLE}
        subtitle={USE_KIOSK_PERMISSION_DESCRIPTION}
        requirePro={true}
        positionKey={'useKiosk'}
      />
    </ConditionalContainer>
  );
};
